import axiosWithToken from "axiosWithToken";
import { ApiResponse } from "./types";

const baseURL2 = process.env.REACT_APP_BASEURL2;

export const inviteMembers = async (emails: string[]): Promise<ApiResponse> => {
  try {
    const payload = { emails };
    const response = await axiosWithToken.post<ApiResponse>(
      `${baseURL2}api/organizations/invite-member`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error inviting members:", error);
    throw error;
  }
};
